import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
import { fadeUp } from '../../utils/motion';
export function SkpLlmTeaser() {
  return <section className="bg-white py-16 lg:py-20 border-y border-line" data-id="element-1381" data-mp="19fxxpu7cavob">
      <motion.div {...fadeUp} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-16 items-center" data-id="element-1382" data-mp="19g6cjrn0wb25">
        <div className="lg:col-span-5" data-id="element-1383" data-mp="223jzcwx0bq8j">
          <p className="text-sm font-medium text-teal mb-3" data-id="element-1384" data-mp="226oake8w3m8p">Related resource · LLM vs. SKP</p>
          <h2 className="font-heading font-bold text-3xl lg:text-4xl text-ink-dark tracking-tight leading-tight" data-id="element-1385" data-mp="1x6ab3klctkma">
            Why not just use an LLM?
          </h2>
        </div>
        <div className="lg:col-span-7" data-id="element-1386" data-mp="1nexiurvn8sfq">
          <p className="text-lg text-ink-muted leading-relaxed mb-6" data-id="element-1387" data-mp="2kv31l1j7j09i">
            Think of the LLM as a capable research assistant. Think of SKP as
            the organization’s working knowledge system: its sources,
            definitions, connected ideas, review decisions, and history.
          </p>
          <a href="/llm-vs-skp" className="inline-flex items-center gap-2 text-navy font-semibold hover:text-navy-light transition-colors duration-150 whitespace-nowrap" data-id="element-1388" data-mp="2506eu5y3c4fc">
            See how they differ and work together
            <ArrowRight size={16} data-id="element-1389" data-mp="1v8sclqer8qii" />
          </a>
        </div>
      </motion.div>
    </section>;
}